<div class="modal_dialog driver-tracking-modal">
  <div class="modal_header">
    <h2>{{ "TrackDriver" | translate }}</h2>
    <button class="btnn close_icon" type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal_body">
    <div class="tracking-info">
      <div class="info-item">
        <span class="label">{{ "OrderNumber" | translate }}:</span>
        <span class="value">#{{ data.order.orderNo }}</span>
      </div>
      <div class="info-item">
        <span class="label">{{ "Status" | translate }}:</span>
        <span class="value status-badge" [ngClass]="{
          'picked-up': currentOrderStatus === orderStatus.ORDER_PICKED_UP,
          'on-the-way': currentOrderStatus === orderStatus.ON_THE_WAY,
          'delivered': currentOrderStatus === orderStatus.DELIVERED
        }">
          <span *ngIf="currentOrderStatus === orderStatus.ORDER_PICKED_UP">{{ "OrderPickedUp" | translate }}</span>
          <span *ngIf="currentOrderStatus === orderStatus.ON_THE_WAY">{{ "OnTheWay" | translate }}</span>
          <span *ngIf="currentOrderStatus === orderStatus.DELIVERED">{{ "Delivered" | translate }}</span>
        </span>
      </div>
      <div class="info-item" *ngIf="data.order.assignedDriver">
        <span class="label">{{ "Driver" | translate }}:</span>
        <span class="value">{{ data.order.assignedDriver.driverId?.name }}</span>
      </div>
    </div>

    <div class="map-container">
      <google-map
        height="500px"
        width="100%"
        [center]="mapCenter"
        [zoom]="13"
        [options]="options">
        
        <!-- Driver Marker -->
        <map-marker
          *ngIf="driverMarker"
          [position]="driverMarker"
          [options]="driverMarkerOptions"
          [title]="'DriverLocation' | translate">
        </map-marker>

        <!-- Dropoff Marker -->
        <map-marker
          *ngIf="dropoffMarker"
          [position]="dropoffMarker"
          [options]="dropoffMarkerOptions"
          [title]="'DeliveryLocation' | translate">
        </map-marker>

        <!-- Route Polyline -->
        <map-polyline
          *ngIf="routePath.length > 0"
          [path]="routePath"
          [options]="{
            strokeColor: '#4285F4',
            strokeOpacity: 1.0,
            strokeWeight: 4
          }">
        </map-polyline>
      </google-map>
    </div>

    <div class="tracking-status" *ngIf="!isTracking && currentOrderStatus === orderStatus.DELIVERED">
      <p class="delivered-message">{{ "OrderDelivered" | translate }}</p>
    </div>
  </div>
</div>

